"use client";

import { Container } from "@mui/material";
import Alert from "@mui/material/Alert";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { type SelectChangeEvent } from "@mui/material/Select";
import { observer } from "mobx-react-lite";
import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";

import { KodikShowPlayer } from "@/features/player/kodik-show-player.js";
import { PlayerIframe } from "@/features/player/player-iframe.js";
import { useOnIframeClick } from "@/shared/lib/on-iframe-click/use-on-iframe-click.js";
import { useSources } from "@/shared/lib/sources-context.js";
import { useStore } from "@/shared/lib/store/use-store.js";

interface ShowExternalPlayerProps {
  readonly tmdbMediaType: "movie" | "tv";
  readonly tmdbId: number;
  readonly imdbId: string;
  readonly onIframeClick?: () => unknown;
}

export const ShowExternalPlayer = observer(
  ({
    // tmdbMediaType,
    // tmdbId,
    imdbId,
    onIframeClick,
  }: ShowExternalPlayerProps) => {
    const {
      player,
      // sources: {
      //   sources,
      //   isError,
      //   isLoading,
      //   firstSource,
      //   preloadHrefs,
      //   getData,
      //   resetData,
      // },
    } = useStore();
    const { formatMessage } = useIntl();
    const { sources } = useSources();

    // useEffect(() => {
    //   getData(tmdbMediaType, tmdbId);

    //   return () => {
    //     resetData();
    //   };
    // }, [tmdbMediaType, tmdbId, getData, resetData]);

    // const preloadResources = useMemo(
    //   () => (
    //     <>
    //       {preloadHrefs.map((href) => {
    //         ReactDOM.prefetchDNS(href);
    //       })}
    //     </>
    //   ),
    //   [preloadHrefs],
    // );

    useOnIframeClick(onIframeClick);

    const handleSourceChange = useCallback(
      ({ target: { value } }: SelectChangeEvent) => {
        player.selectSource(value);
      },
      [player],
    );

    const selectedSource = useMemo(() => {
      // const hasSelectedSource =
      //   Boolean(sources.find(({ type }) => type === player.selectedSource)) ||
      //   player.selectedSource === "KODIK";

      // if (!hasSelectedSource && firstSource !== undefined) {
      //   return firstSource.type;
      // }

      return player.selectedSource.toUpperCase();
    }, [player.selectedSource]);

    const iframeUrl = sources.find((source) => source.type === selectedSource)
      ?.iframe.url;

    // if (isLoading) {
    //   return (
    //     <Container
    //       sx={{
    //         display: "flex",
    //         flexDirection: "column",
    //         gap: 2,
    //         paddingBottom: 0,
    //         bgcolor: "rgba(0, 0, 0, 0.11)",
    //         borderRadius: 1,
    //       }}
    //     >
    //       <PlayerSkeleton />
    //     </Container>
    //   );
    // }

    // if (isError) {
    //   return (
    //     <Container
    //       sx={{
    //         display: "flex",
    //         flexDirection: "column",
    //         gap: 2,
    //         paddingBottom: 0,
    //         bgcolor: "rgba(0, 0, 0, 0.11)",
    //         borderRadius: 1,
    //       }}
    //     >
    //       <PlayerError />
    //     </Container>
    //   );
    // }

    return (
      <>
        {/* {preloadResources} */}
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            paddingBottom: 0,
            bgcolor: "rgba(0, 0, 0, 0.11)",
            borderRadius: 1,
          }}
        >
          <Alert severity="warning">
            {formatMessage({ id: "show_player_external_disclaimer" })}
          </Alert>
          <FormControl>
            <InputLabel>
              {formatMessage({ id: "show_player_external_source" })}
            </InputLabel>
            <Select
              value={selectedSource}
              label={formatMessage({ id: "show_player_external_source" })}
              onChange={handleSourceChange}
            >
              {sources.map((source, index) => (
                <MenuItem key={index} value={source.type}>
                  {source.name}
                </MenuItem>
              ))}
              <MenuItem value="KODIK">Kodik</MenuItem>
            </Select>
          </FormControl>

          <div key={selectedSource}>
            {selectedSource === "KODIK" ? (
              <KodikShowPlayer imdbId={imdbId} key={imdbId} />
            ) : (
              <PlayerIframe src={iframeUrl!} key={iframeUrl} />
            )}
          </div>
        </Container>
      </>
    );
  },
);
